import { Switch } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../../../util/store/store';
import { overviewActions } from '../reducer';

const ShowAllPlans: React.FC = () => {
    const dispatch = useDispatch();
    const showAllPlans = useSelector(state => state.overview.showAllPlans);
    const hasWellboats = useSelector(state => state.overview.wellboats.vessels.length > 0);

    if (!hasWellboats)
        return null;

    return <div className="flex items-center gap-2 mx-2">
        <span className="text-[14px]">Show all plans</span>
        <Switch
            checked={showAllPlans}
            onChange={checked => dispatch(overviewActions.setShowAllPlans(checked))}
        />
    </div>;
};

export default ShowAllPlans;
